import { mode } from "../config";

const authPageOrigins = [
  "https://auth.medtankengroup.se",
  "https://auth.medtankengroup.se",
  "https://auth-test.vasterleden.se",
  "http://localhost:3001",
];

export const endpoints = {
  AUTH_PAGE: authPageOrigins[mode],

  SITHS_CHECK_AUTH: "siths/check-authentication/",
  SITHS_REQUEST_AUTH: "siths/request-auth/",
  SITHS_AUTHENTICATE: "siths/authenticate/",
  SITHS_LOGOUT: "siths/logout/",
  SITHS_SESSION: "siths/session/",

  BANKID_SESSION: "bankid/session/",
};
